import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/home.vue';

const routes = [
	{
		path: '/',
		name: 'home',
		component: Home,
	},
]

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  mode: 'history',
  base: '/cloud-home',
});

export default router;
